/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated do not edit it manually",
 */
import React from "react";

import { linkedin } from "../assets/linkedin";
import { Icon, type IconBaseProps } from "../icon";

export const IconLinkedin = (props: IconBaseProps) => <Icon {...props} svg={linkedin} />;

IconLinkedin.displayName = "IconLinkedin";
